export const UAMF_WS_KEEP_ALIVE_INTERVAL = 9 * 60 * 1000;
export const UAMF_WS_PING_MESSAGE = '{"action":"ping"}';
export const UAMF_WS_PONG_RESPONSE = 'pong';
